'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import { UnderlineEffect } from '@/shared/ui/underline-effect';
import { DesktopLanguageSelector } from './DesktopLanguageSelector';
interface Props {
  cityAlias: string;
}
export const HeaderMenu: React.FC<Props> = ({
  cityAlias
}) => {
  const t = useTranslations('shared.header');
  const navigationItems = [{
    href: `/${cityAlias}/doctors`,
    text: t('doctors')
  }, {
    href: `/${cityAlias}/medcenters`,
    text: t('medcenters')
  }, {
    href: `/${cityAlias}/services`,
    text: t('services')
  }, {
    href: `/${cityAlias}/lechenie`,
    text: t('treatment')
  }];
  return <>
      <nav className="hidden pr-1 lg:block">
        <ul className="flex whitespace-nowrap text-sm">
          {navigationItems.map(item => <li key={item.href}>
              <Link prefetch={false} href={item.href} className="px-1">
                <UnderlineEffect direction={'center'}>{item.text}</UnderlineEffect>
              </Link>
            </li>)}
        </ul>
      </nav>

      <DesktopLanguageSelector data-sentry-element="DesktopLanguageSelector" data-sentry-source-file="HeaderMenu.tsx" />
    </>;
};